import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Typography, Tooltip } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

const { Text } = Typography;
const AddressCell = ({ id, address, copied, handleCopy, transactionSource, transactionAction, type, IbanNumber, swfitcode }) => {
  const addressData = useMemo(() => {
    if ((transactionSource?.toLowerCase() === 'cards') || type === 'Fiat') {
      return address;
    }
    if ((address && IbanNumber) && (address === IbanNumber || swfitcode)) {
      return `${address.substring(0, 4)}....${address.substring(address.length - 4)}`;
    }
    if (address) {
      return `${address.substring(0, 8)}....${address.substring(address.length - 8)}`;
    }
    return '';
  }, [address, transactionSource, transactionAction, type, IbanNumber, swfitcode]);

  return (
    <td style={{ paddingRight: 25 }}>
      {!address && <div className='text-center text-white'></div>}
      {address && copied !== id && (
        <Text
          key={id}
          className="text-light-valueColor flex justify-between"
          copyable={{ text: address, onCopy: () => handleCopy(id) }}
          options={{ format: 'text/plain' }}
        >
          <span className='text-light-valueColor dark:text-dark-valueColor'>{addressData}</span>
        </Text>
      )}
      {copied === id && (
        <Text className="text-white flex justify-between" key={id}>
          <span className='text-light-valueColor dark:text-dark-valueColor'>{addressData}</span>
          <Tooltip title="Copied" open={copied === id}>
            <CheckOutlined style={{ marginLeft: 8, color: 'green' }} />
          </Tooltip>
        </Text>
      )}
    </td>
  );
};

AddressCell.propTypes = {
  id: PropTypes.string.isRequired,
  address: PropTypes.string,
  copied: PropTypes.string,
  handleCopy: PropTypes.func.isRequired,
  transactionSource: PropTypes.string,
  transactionAction: PropTypes.string,
  type: PropTypes.string,
};

export default AddressCell;
